import useStore from './useStore';
import { StoreContext } from '../stores';

const useSessionStore = <R = unknown>(dataSelector?: (store: unknown) => R) => 
  useStore(
    StoreContext, 
    (value) => value.sessionStore, 
    dataSelector || ((store) => store as R)
  );

export default useSessionStore;
